import * as Sentry from '@sentry/gatsby';

Sentry.init({
	dsn: process.env.GATSBY_SENTRY_DSN,
	enabled: !!process.env.GATSBY_SENTRY_DSN,
	sampleRate: 1.0,
	tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
	environment: process.env.NODE_ENV || 'development',
	release: process.env.GATSBY_RELEASE_VERSION || 'dev',
	// Configuración de privacidad y filtrado
	beforeSend(event: any, hint: any) {
		// Filtrar datos sensibles
		if (event.request?.headers) {
			delete event.request.headers['Authorization'];
			delete event.request.headers['Cookie'];
		}

		// Filtrar URLs con tokens en query params
		if (event.request?.url) {
			event.request.url = event.request.url.replace(/([?&]token=)[^&]+/, '$1[REDACTED]');
		}

		// No enviar en desarrollo
		// if (process.env.NODE_ENV === 'development') {
		// 	console.log('[Sentry Dev]', event.message || event.exception, event);
		// 	return null;
		// }

		return event;
	},
	// Ignorar errores comunes no críticos
	ignoreErrors: [
		// Errores de red comunes
		'Non-Error promise rejection',
		'Network request failed',
		'Failed to fetch',
		'Load failed',
		'NetworkError',
		'timeout',

		// Errores de navegador
		'ResizeObserver loop limit exceeded',
		'ResizeObserver loop completed with undelivered notifications',

		// Errores de usuario (cancelaciones)
		'cancelled',
		'AbortError',
		'The user aborted a request',

		// Errores de Firebase comunes (no críticos)
		'auth/popup-closed-by-user',
		'auth/cancelled-popup-request',

		// Errores de extensiones de navegador
		'top.GLOBALS',
		'originalCreateNotification',
		'canvas.contentDocument',
		'MyApp_RemoveAllHighlights',
		'atomicFindClose',
	],
	// Ignorar errores de ciertos dominios
	denyUrls: [
		// Extensiones de Chrome
		/extensions\//i,
		/^chrome:\/\//i,
		/^chrome-extension:\/\//i,
		// Scripts de terceros
		/google-analytics\.com/i,
		/googletagmanager\.com/i,
	],
	// Breadcrumbs automáticos mejorados
	beforeBreadcrumb(breadcrumb: any, hint: any) {
		// Filtrar breadcrumbs de console en producción
		if (breadcrumb.category === 'console' && process.env.NODE_ENV === 'production') {
			return null;
		}

		// Filtrar datos sensibles en breadcrumbs
		if (breadcrumb.data) {
			if (breadcrumb.data.url) {
				breadcrumb.data.url = breadcrumb.data.url.replace(/([?&]token=)[^&]+/, '$1[REDACTED]');
			}
		}

		return breadcrumb;
	},
});
